// extracted by mini-css-extract-plugin
module.exports = {"flash-container":"Flash-module__flash-container___3Z0j0","client-flash":"Flash-module__client-flash___2024V","fadeout-anim":"Flash-module__fadeout-anim___29n-M"};